// removed by extract-text-webpack-plugin
module.exports = {"slide":"_2UAoUpntm045cKpohqGd6c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/CompanyGallery/CompanyGallery.scss
// module id = 1572
// module chunks = 0